// Function loadCareculator loads the Careculator class by dynamically importing the js on demand if needed

export function loadCareculator($parentEl, isList = false) {

	return import(/* webpackChunkName: "wg-careculator-chunk" */ '../widgets/careculator').then(wg => {

		const { Careculator } = wg;

		let $wg = $parentEl.querySelector('[data-wg="Careculator"]');

		if(!$wg) {
			// console.info('Careculator: no widget found');
			return null;
		}

		if (isList) {
			let $wgCol = $parentEl.querySelectorAll('[data-wg="Careculator"]');
			let instances = [];
			$wgCol.forEach(($wg, i) => {
				instances.push( new Careculator($wg) );
			});
			if (instances.length === $wgCol.length) return instances;

		} else {
			return new Careculator($wg);
		}


	}).catch(error => error+'An error occurred while loading the Careculator widget');

}
